export const PlayIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="62"
    height="69"
    viewBox="0 0 62 69"
    fill="none"
  >
    <g filter="url(#filter0_d_15_1867)">
      <path
        d="M52.7129 29.3038C56.7129 31.6132 56.7129 37.3867 52.7129 39.6962L15.2873 61.3038C11.2873 63.6133 6.28727 60.7265 6.28727 56.1077V12.8923C6.28727 8.2735 11.2873 5.38675 15.2873 7.69615L52.7129 29.3038Z"
        fill="white"
        fillOpacity="0.9"
        shapeRendering="crispEdges"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_15_1867"
        x="0.287109"
        y="0.883362"
        width="61.4258"
        height="67.2333"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_15_1867"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_15_1867"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)